import { commsManager } from "appworks/server/comms-manager";
import { Contract } from "appworks/utils/contracts/contract";
import { gamevyForceData } from "gamevy/components/gamevy-force-data";
import { AdditionalForceData } from "gamevy/integration/builders/requests/force-request-payload";
import { GamevyOfflineHTTPConnector } from "gamevy/server/connectors/gamevy-offline-http-connector";
import { ForceList } from "slotworks/debug/menu/force-list";

class GamevyForceResults implements ForceList {

    private forceData: Map<string, AdditionalForceData> = new Map<string, AdditionalForceData>();

    public setForceData(data: Map<string, AdditionalForceData>) {
        this.forceData = data;
    }

    public getList(): Contract<string[]> {
        return new Contract<string[]>((resolve) => {
            resolve(Array.from(this.forceData.keys()));
        });
    }

    public force(id: string): Contract<void> {
        const data = this.forceData.get(id);
        if (data.offline && commsManager.connector instanceof GamevyOfflineHTTPConnector) {
            (commsManager.connector as GamevyOfflineHTTPConnector).setDemoResults(data.results);
        } else {
            gamevyForceData.setForceData(data);
        }
        return Contract.empty();
    }
}

export const gamevyForceResults = new GamevyForceResults();
